<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Col, Row } from "sveltestrap";
	import client from "../../../../services/client";
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import NoData from "../../../../components/NoDataPage/NoData.svelte";
	import PendingIssue from "./PendingIssue.svelte";
	import SwitchComponent from "./SwitchComponent.svelte";
	import {
		errorMessage,
		loading,
		vehicleId,
		issueDetail,
		imageLightbox,
	} from "../../../../store/store";
	import Swal from "sweetalert2";

	let issues = [];
	let img_url = [];

	onMount(async () => {
		try {
			loading.set(true);
			issueDetail.set("");
			const res = await client("/v0/Issue/GetIssueForCompareMode", {
				method: "GET",
				version: "Tasking",
			});
			issues = res.data.data;
			img_url = issues.imageUrls;
			vehicleId.set(res.data.data.vehicleId);
			imageLightbox.set(img_url);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err.response);
		}
	});

	const trigerAlert = setTimeout(() => {
		Swal.fire({
			title: "Session expiring",
			text: "Your session will expire in 60 seconds. Do you want to extend the session?",
			showCancelButton: true,
			confirmButtonColor: "#006DE1",
			timer: 60000,
			cancelButtonColor: "red",
			confirmButtonText: "Extend session",
			cancelButtonText: "Leave session",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const res = await client(
					`/v0/Issue/ExtendSession/${issues.issueId}`,
					{
						method: "POST",
						version: "Tasking",
					}
				);
				if (res.data.error_code == 0) {
					Swal.fire("Your session has been extended!");
				} else {
					navigate("/issue-management/issues-pending-review");
				}
			} else {
				navigate("/issue-management/issues-pending-review");
			}
		});
	}, 4 * 60 * 1000);

	onDestroy(() => {
		clearTimeout(trigerAlert);
	});

	const fetchIssue = async (req, res) => {
		try {
			loading.set(true);
			issueDetail.set("");
			const res = await client("/v0/Issue/GetIssueForCompareMode", {
				method: "GET",
				version: "Tasking",
			});
			issues = res.data.data;
			vehicleId.set(res.data.data.vehicleId);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err.response);
		}
	};
</script>

<Row>
	<Col>
		<Col className="row d-flex align-items-start mx-0 ">
			<PageHeader title="Compare Mode" />
		</Col>
		<LoaderContainer>
			{#if !issues}
				<NoData />
			{:else}
				<Row>
					<Col xs={6}>
						<PendingIssue {issues} {img_url} {fetchIssue} />
					</Col>
					<Col xs={6}>
						<Row>
							<Col>
								<SwitchComponent {issues} />
							</Col>
						</Row>
					</Col>
				</Row>
			{/if}
		</LoaderContainer>
	</Col>
</Row>
